import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import React from 'react';
import PropTypes from 'prop-types';

const UpdateVisibilityModal = ({ onConfirm, onCancel, isStudentVisible }) => {
  const title = isStudentVisible
    ? 'Hide Labels from Students'
    : 'Show Labels to Students';
  const text = isStudentVisible
    ? 'Students will not see any labels.\n' +
      'Do you want to hide labels from students?'
    : 'Only labels with resources you’ve assigned to students will be visible to those students. \n' +
      '\n' +
      'Do you want to show labels to students?';

  const onSuccess = () => {
    onConfirm();
    onCancel();
  };
  return (
    <ConfirmDialog
      title={title}
      onSuccess={onSuccess}
      onClose={onCancel}
      content={{ btnPrimary: 'Yes', btnSecondary: 'No' }}
    >
      <p className="margin-0 text-gray-700 font-normal text-16">{text}</p>
    </ConfirmDialog>
  );
};

UpdateVisibilityModal.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  isStudentVisible: PropTypes.bool,
};

UpdateVisibilityModal.defaultProps = {
  onConfirm: () => {},
  onCancel: () => {},
  isStudentVisible: false,
};

export default UpdateVisibilityModal;
